import { cloneObject } from '../../../utilities';

const getXAxisQuill = (_xAxisField, _fields) => {
  const xAxisQuill = {
    ops: [
      {
        insert: {
          inlineValue: {
            fieldName: _xAxisField,
            title: _fields[_xAxisField].title,
            format: cloneObject(_fields[_xAxisField].format),
          },
        },
      },
      { insert: '\n' },
    ],
  };

  return xAxisQuill;
};

export default getXAxisQuill;
